import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RecipeDetailModal } from "../components/discover/RecipeDetailModal";
import { RecipePage } from "./RecipePage";
import { getRecipe } from "wasp/client/operations";

export function RecipeDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [recipe, setRecipe] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    const loadRecipe = async () => {
      try {
        setLoading(true);
        // getRecipe accepts slug but tries ID as fallback, so this works for both
        const result = await getRecipe({ slug: id });
        setRecipe(result);
      } catch (err) {
        console.error("Error loading recipe:", err);
      } finally {
        setLoading(false);
      }
    };

    loadRecipe();
  }, [id]);

  const handleClose = () => {
    navigate(-1);
  };

  // Render the Discover page in background with modal on top
  return (
    <>
      <RecipePage />
      {!loading && recipe && (
        <RecipeDetailModal
          recipe={recipe}
          isOpen={true}
          onClose={handleClose}
        />
      )}
    </>
  );
}
